//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";

var now = moment();

export default {
    props: {
        //@TODO - with parent, rename this to `item`
        resident: {
            type: Object
        }
    },
    watch: {
        resident: function resident(_resident, oldResident) {
            this.refreshResidentLedger();
        }
    },
    data: function data() {
        return {
            selectedRow: false,
            hideInProd: window.validator.hideInProd(),
            mod: false,
            add: false,
            override: false,
            amount: 0.0,
            overrideAmount: 0.0,
            postDate: now.format("MM-DD-YYYY"),
            dueDate: now.format("MM-DD-YYYY"),
            transactions: [],
            payments: [],
            loading: true,
            unitsForSelect: [],
            fabOpened: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (this.resident.id) this.refreshResidentLedger();
        Event.$on('refresh-resident-ledger', function () {
            _this.refreshResidentLedger();
        });
        Event.$on('refresh-past-resident-ledger-charge', this.refreshResidentLedger);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refresh-resident-ledger');
        Event.$off('refresh-past-resident-ledger-charge');
    },

    methods: {
        getUnits: function getUnits() {

            var self = this;

            axios.get('/prototype/properties/get-all-units').then(function (response) {

                if (response.data) {

                    self.units = response.data;

                    self.unitsForSelect = self.units.map(function (u) {
                        return {
                            label: u.name,
                            value: u.id,
                            price: u.rent_amount
                        };
                    });
                }
            });
        },
        refreshResidentLedger: function refreshResidentLedger() {
            var _this2 = this;

            var $el = this;
            axios.post("/prototype/resident/ledger", { id: $el.resident.id }).then(function (response) {
                if (response.data) {
                    $el.transactions = response.data.transactions;
                    $el.transactions.map(function (trans) {
                        return trans["type"] = "transaction";
                    });
                    $el.payments = response.data.payments;
                    $el.payments.map(function (payment) {
                        return payment["type"] = "payment";
                    });
                    _this2.getUnits();
                }
                $el.loading = false;
            });
        },
        addRefund: function addRefund() {
            Event.$emit("refund-preview", this.resident);
        },
        pastDue: function pastDue(due) {
            return moment(due).diff(moment()) <= 0;
        },
        modify: function modify() {
            Event.$emit("modify-ledger-entry");
        },
        addNew: function addNew() {
            Event.$emit('show-gl-wizard', this.resident);
        },
        showCalculator: function showCalculator() {
            Event.$emit('show-prorated-calculator', { person: this.resident }, this.resident.unit, this.unitsForSelect, false, true);
        },
        editTransaction: function editTransaction(transaction) {
            Event.$emit("edit-gl-wizard", transaction);
        },
        modifyPayment: function modifyPayment(payment) {
            Event.$emit("edit-ledger-payment-resident", payment);
        },
        sendBalanceNotification: function sendBalanceNotification() {
            var $el = this,
                transAmount;

            this.transactions.filter(function (t) {
                var due = moment(t.due_at, "YYYY-MM-DD");
                return now.valueOf() < due.valueOf() && due.diff(now, "days") <= 5;
            }).forEach(function (t, index) {
                transAmount += t.amount;
            });

            axios.post("/prototype/resident/ledger/notify", {
                resident: $el.resident.id,
                transaction: transAmount
            }).then(function (response) {
                $el.$snotify.success("The notification is queued to send");
            });
        },

        printLedger: function printLedger() {
            return '/prototype/accounting/accounts-receivable/reports/single-ledger?resident_id=' + this.resident.id + '&exportPDF=true';
        },
        addDeposit: function addDeposit() {
            this.resident.formType = "current";
            Event.$emit("new-ar-deposit", this.resident);
        },

        ledgerLink: function ledgerLink() {
            return "/prototype/accounting/accounts-receivable/reports/single-ledger?resident_id=" + this.resident.id + "&exportPDF=true";
        },
        downloadFile: function downloadFile(response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], { type: "application/pdf" });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            var data = window.URL.createObjectURL(newBlob);
            var link = document.createElement("a");
            link.href = data;
            link.download = filename + ".pdf";
            link.click();
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100);
        },
        openSodaGoogleForm: function openSodaGoogleForm(resident) {
            var formId = "1FAIpQLSe3J1vlFo4FYoRnMr97Dr-SHjheuS-VrJqquk2DTwrlKrndcg";
            var formUrl = "https://docs.google.com/forms/d/e/" + formId + "/viewform";
            var queryString = "";
            //Try to build a pre-filled URL query string if the resident data exists
            if (resident && resident.property && resident.unit && resident.person && resident.lease) {
                var queryStringParams = {
                    usp: "pp_url",
                    //Property Name
                    "entry.942210355": "" + (resident.property.name || ""),
                    //Unit Number
                    "entry.1106012368": "" + (resident.unit.name || ""),
                    //Resident Name
                    "entry.1974080188": "" + (resident.person.full_name || ""),
                    //Rent Amount
                    "entry.2025622215": "" + (resident.lease.actual_rent_amount || "")
                };

                queryString = Object.keys(queryStringParams).map(function (key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(queryStringParams[key]);
                }).join("&");
            }

            window.open(formUrl + "?" + queryString, '_blank');
        }
    },
    computed: {
        filteredData: function filteredData() {
            var data = this.transactions.concat(this.payments);

            if (data.length) {
                //Put all transactions in ascending order to calculate balances
                // This is intentionally done on "id" to force a consistent order
                // that can be used in the pdf logic as well
                data.sort(function (a, b) {
                    var aDate = new Date(a.type === "transaction" ? moment(a.due_at).toDate() : moment(a.created_at).toDate()).getTime();
                    var bDate = new Date(b.type === "transaction" ? moment(b.due_at).toDate() : moment(b.created_at).toDate()).getTime();

                    if (aDate === bDate) {
                        return a.id - b.id;
                    }

                    return aDate - bDate;
                });

                data.map(function (item, idx) {
                    if (item.type === "transaction") {
                        var amount = item["has_override"] ? Number(item["override_amount"]) : Number(item["true_amount"]);

                        if (item.is_debit) {
                            if (idx === 0) {
                                item["lineBalance"] = amount;
                            } else {
                                item["lineBalance"] = (Number(data[idx - 1]["lineBalance"]) + Number(amount)).toFixed(2);
                            }
                        } else {
                            if (idx === 0) {
                                item["lineBalance"] = -amount;
                            } else {
                                item["lineBalance"] = (Number(data[idx - 1]["lineBalance"]) - Number(amount)).toFixed(2);
                            }
                        }
                    }

                    if (item.type === "payment") {
                        // Reversed payments should not be tallied in running balance
                        if (item.reversal === null) {
                            if (idx === 0) {
                                item["lineBalance"] = -Number(item.amount);
                            } else {
                                item["lineBalance"] = (Number(data[idx - 1]["lineBalance"]) - Number(item.amount)).toFixed(2);
                                return item["lineBalance"]; //what does this do?
                            }
                        } else {
                            if (idx === 0) {
                                item["lineBalance"] = 0;
                            } else {
                                item["lineBalance"] = Number(data[idx - 1]["lineBalance"]);
                            }
                        }
                    }
                });

                //Reverse the sort for display, latest first
                data.reverse();
            }

            return data;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentLedger.vue
// module id = ng0r
// module chunks = 0 1